import { FC } from "react";
import { ReactComponent as RightArrow } from "../../assets/img/rightArrow.svg";
import { ReactComponent as RemitaWalletDesign } from "../../assets/img/remitaWalletDesign.svg";
import { ReactComponent as WebBgIcon } from "../../assets/img/webbgIcon.svg";
import { ReactComponent as WalletTextIcon } from "../../assets/img/wallet.svg";
 import { DashboardCard } from "./DashboardCard";
import Button from "../UIKits/Button/Button";
import { formatCurrency } from "../../helper/helper";

interface WalletCardProps {
  balance: number;
  onFundWallet: () => void;
  onBuyPower?: () => void;
  isAdmin?: boolean;
  loading?: boolean;
}


export const WalletCard: FC<WalletCardProps> = ({ balance, loading, onFundWallet, onBuyPower, isAdmin = false }) => {
  return (
    <DashboardCard gradient="white" className=" w-full border border-ash ">
      <div
        className={`${
          isAdmin ? "w-5/6  " : " w-5/6 lg:w-1/2"
        } flex flex-col justify-between p-3   rounded-[20px] bg-white`}
      >
        <div className="space-y-2">
          <p className="text-lightBlack text-xs">Wallet balance</p>
          <p className="text-xl font-medium font-sans">{loading ? "loading..." : formatCurrency(balance)}</p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onFundWallet}
            className={`font-medium w-full flex items-center py-2 p-3 bg-ash text-black rounded-lg hover:bg-gray-200 transition-colors ${
              isAdmin ? "justify-center" : "justify-between"
            }`}
          >
            Fund wallet
            {!isAdmin && (
              <span className="flex w-4 h-4">
                <RightArrow className="fill-black" />
              </span>
            )}
          </button>

          {isAdmin && onBuyPower && (
            // <button
            //   onClick={onBuyPower}
            //   className="font-medium w-full flex justify-center items-center py-2 p-3 bg-darkGreen text-white rounded-lg hover:bg-darkerGreen transition-colors"
            // >
            //   Buy power
            // </button>
            <Button onClick={onBuyPower}   className="w-full">Buy power</Button>
          )}
        </div>
      </div>

      <div className={`${  "w-2/6 lg:w-1/3"}  min-h-[200px] flex justify-end relative`}>
        <div className="h-full w-[70%] flex box-border py-1.5 relative">
          <span className="flex w-full absolute top-0 right-0">
            <WebBgIcon />
          </span>
          <div className="h-full w-full bg-lighterYellow flex justify-between rounded-2xl p-2 pr-0">
            <div className="flex items-end pb-4 pl-3.5">
              <WalletTextIcon />
            </div>
            <div className="h-full w-[40%] bg-lightYellow rounded-lg flex items-end pb-4 pl-3.5">
              <RemitaWalletDesign />
            </div>
          </div>
        </div>
      </div>
    </DashboardCard>
  );
};
